var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 17C3.71667 17 3.479 16.904 3.287 16.712C3.095 16.52 2.99934 16.2827 3 16C3 15.7167 3.096 15.479 3.288 15.287C3.48 15.095 3.71734 14.9993 4 15C4.28334 15 4.521 15.096 4.713 15.288C4.905 15.48 5.00067 15.7173 5 16C5 16.2833 4.904 16.521 4.712 16.713C4.52 16.905 4.28267 17.0007 4 17ZM4 13C3.71667 13 3.479 12.904 3.287 12.712C3.095 12.52 2.99934 12.2827 3 12C3 11.7167 3.096 11.479 3.288 11.287C3.48 11.095 3.71734 10.9993 4 11C4.28334 11 4.521 11.096 4.713 11.288C4.905 11.48 5.00067 11.7173 5 12C5 12.2833 4.904 12.521 4.712 12.713C4.52 12.905 4.28267 13.0007 4 13ZM4 9C3.71667 9 3.479 8.904 3.287 8.712C3.095 8.52 2.99934 8.28267 3 8C3 7.71667 3.096 7.479 3.288 7.287C3.48 7.095 3.71734 6.99934 4 7C4.28334 7 4.521 7.096 4.713 7.288C4.905 7.48 5.00067 7.71734 5 8C5 8.28334 4.904 8.521 4.712 8.713C4.52 8.905 4.28267 9.00067 4 9ZM7 17V15H21V17H7ZM7 13V11H21V13H7ZM7 9V7H21V9H7Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.5e293df47b8842377fb2b245054b4d1f.svg";
export { ForwardRef as ReactComponent };